document.addEventListener("DOMContentLoaded", function (event) {

    const menuWrapper = document.getElementById("anchor-menu-wrapper");
    const menu = document.getElementById("anchor-menu");
    const title = document.querySelector("#anchor-menu-wrapper h3");
    const titleText = document.querySelector("#anchor-menu-wrapper h3 span");
    const titles = document.querySelectorAll("h2.title");
    titleText.innerText = titles[0].innerText;
    title.onclick = () => {
        menuWrapper.classList.contains("on")?menuWrapper.classList.remove("on"):menuWrapper.classList.add("on");

    }
    titles.forEach((t) => {
        if (t.innerText) {
            const el = document.createElement("li")
            const link = document.createElement("a")
            link.innerText = t.innerText
            link.onclick = () => {
                titleText.innerText = t.innerText;
                menuWrapper.classList.remove("on");
                t.scrollIntoView({behavior: "smooth"});
            }
            el.appendChild(link);
            menu.appendChild(el);
        }

    });
});